// extracted by mini-css-extract-plugin
module.exports = {"spin":"ui-icons_spin__Bpz7I","rotation":"ui-icons_rotation__hl5JG"};